export default __webpack_public_path__ + "static/media/sagar@4x.73968652.png";